<template>
  <div class="checkbox is-facet-term">
    <input type="checkbox" :checked="term.active" @input="termClick" />
    <NuxtLink :to="to">{{ term.label }} <slot /> </NuxtLink>
    <span class="count">{{ term.count }}</span>
  </div>
</template>

<script lang="ts" setup>
import { getQueryParamArray } from '~/helpers'
import type { SearchFacetTerm } from '~~/layers/legacy-search/app/types'

/*
Original props:
props: {
 facetId: {
   type: String,
   default: '',
 } as PropOptions<string>,
 term: {
   type: Object,
   default: undefined,
 } as PropOptions<SearchFacetTerm>,
}
*/
const props = withDefaults(
  defineProps<{
    facetId: string
    term: SearchFacetTerm
  }>(),
  {
    facetId: '',
  },
)

const route = useRoute()
const router = useRouter()

/*
Original function:
export function getTermLink(
 routeQuery: Record<string, any>,
 facetId: string,
 term: SearchFacetTerm
) {
 const id = facetId + ':' + term.key
 const query = { ...routeQuery } || {}
 delete query.page
 const facetItems = getQueryParamArray(query, 'f')
 let f = [...facetItems]
 if (term.active) {
   f = f.filter((v) => v !== id)
 } else {
   f.push(id)
 }
 query.f = f
 return {
   query,
 }
}
*/
function getTermLink(
  routeQuery: Record<string, any>,
  facetId: string,
  term: SearchFacetTerm,
) {
  const id = facetId + ':' + term.key
  const query = { ...routeQuery }
  delete query.page
  const facetItems = getQueryParamArray(query, 'f')
  let f = [...facetItems]
  if (term.active) {
    f = f.filter((v) => v !== id)
  } else {
    f.push(id)
  }
  query.f = f
  return {
    query,
  }
}

/*
Original computed:
to(): any {
 return {
   ...getTermLink(this.$route.query, this.facetId, this.term),
 }
}
*/
const to = computed(() => {
  return {
    ...getTermLink(route.query, props.facetId, props.term),
  }
})

/*
Original method:
termClick() {
 this.$router.push(this.to)
}
*/
function termClick() {
  router.push(to.value)
}
</script>

<style lang="postcss">
.checkbox.is-facet-term {
  @apply flex w-full;
  a {
    flex: 1;
  }
  &:not(:last-child) {
    margin-bottom: 0.5em;
  }
  .count {
    @apply text-size-6;
    margin-left: auto;
  }
}
</style>
